import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CaretDown from "Images/profile/CaretDown.svg";
import LargeFont from "../LargeFont";
import styles from "./styles.module.scss";
const ProductAccordion = ({ title, accOpened, i, toggleAccordions, isV2, children, }) => {
    const toggleAccordion = () => {
        toggleAccordions(accOpened, i);
    };
    return (_jsxs("div", { className: `${isV2 ? styles.accordion_v2 : ""} ${accOpened ? styles.accordion_wrapper_opened : ""} ${styles.accordion_wrapper} `, children: [_jsxs("button", { "data-attr": "subscription-toggle-accordion-button", onClick: toggleAccordion, type: "button", className: styles.accordion_header, children: [_jsx(LargeFont, { fontWeight: accOpened ? 400 : 200, children: title }), _jsx("span", { className: styles.accordion_collapse_button, children: _jsx("img", { src: CaretDown, alt: "" }) })] }), _jsx("div", { className: styles.accordion_body, children: children })] }));
};
export default ProductAccordion;
